import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function getUtm() {
  try {
    const p = new URLSearchParams(window.location.search);
    return p.get("utm_source") || document.referrer || null;
  } catch {
    return null;
  }
}

export async function submitEnquiry(payload) {
  const res = await axios.post(`${API}/enquiries`, {
    ...payload,
    utm_source: getUtm(),
  });
  return res.data;
}

export async function uploadPitchDeck(file, onProgress) {
  const fd = new FormData();
  fd.append("file", file);
  const res = await axios.post(`${API}/uploads`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    },
  });
  return res.data;
}
